import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { EmployerMatch } from '../../components/EmployerMatch/EmployerMatch';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { IsSpouseSingleBeneficiary } from '../../components/IsSpouseSingleBeneficiary/IsSpouseSingleBeneficiary';
import { PercentageUsedInPlan } from '../../components/PercentageUsedInPlan/PercentageUsedInPlan';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <AccountEarmark />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
      <IsSpouseSingleBeneficiary />
      <PercentageUsedInPlan />
    </TabWrapper>
  );
};

export const TaxDeferred = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        {
          name: 'Employer Match',
          Component: () => (
            <EmployerMatch hasNonElectiveContribution={false} hasSelfEmployedContribution />
          ),
        },
        { name: 'Details', Component: AccountDetails },
      ]}
    />
  );
};
